module.exports = __webpack_public_path__ + "img/scene_office.b4c446d6.webp";